const messages = {
  name: 'Pricing |||| Pricings',
  matrix: {
    hint: 'Credit cost per message of each channel for each account. Bold cells are custom prices; dimmed cells use the channel default. Type a value to customise; clear it to revert to the default. Saved on blur. Pick a preset tariff and its prices apply and the cells lock.',
    empty: 'No accounts with a cost center.',
    account: 'Account',
    default: 'Default',
    tariff: 'Tariff',
    noTariff: 'No tariff (default)',
    filterAccount: 'Account',
    application: 'Application',
    accountLevel: 'Account level (all)',
    inherit: 'Inherit from account',
    inheritNamed: 'Inherit from account (%{name})',
  },
  tariffs: {
    title: 'Preset tariffs',
    hint: 'Define tariffs with a price per channel and assign them to accounts on the pricing screen. An empty channel uses the platform default.',
    add: 'New tariff',
    name: 'Name',
    empty: 'No preset tariffs yet.',
    createTitle: 'New tariff',
    editTitle: 'Edit tariff',
    pricesHint: 'Credit price per channel. Leave a channel empty to use the default.',
    nameRequired: 'Name is required.',
    invalidPrice: 'Invalid price for %{channel}.',
    saved: 'Tariff saved.',
    deleted: 'Tariff deleted.',
    confirmDelete: 'Delete tariff "%{name}"? Accounts using it revert to default pricing.',
  },
  fields: {
    costCenterId: 'Cost Center',
    applicationId: 'Application',
    communicationChannel: 'Communication Channel',
    pricePerUnit: 'Price Per Unit',
    // Joined display fields used in the list view.
    costCenterName: 'Cost Center',
    applicationName: 'Application',
  },
  empty: 'No pricings yet',
  invite: 'Add your first pricing',
  filters: {
    costCenter: 'Cost Center',
    application: 'Application',
    communicationChannel: 'Communication Channel',
  },
  actions: {
    addPricing: 'Add Pricing',
  },
  dialog: {
    title: 'Pricing Details',
  },
  validation: {
    required: '%{field} is required',
    minValue: '%{field} must be greater than or equal to %{min}',
    positive: '%{field} must be greater than 0',
  },
  create: { title: 'Create Pricing' },
  edit: { title: 'Edit Pricing' },
  sections: {
    basicInfo: 'Pricing Details',
  },
  delete: {
    title: 'Delete pricing for "%{recordName}"',
    content: 'Are you sure you want to delete this pricing? This action cannot be undone.',
  },
  notifications: {
    created: 'Pricing created successfully',
    updated: 'Pricing updated successfully',
    deleted: 'Pricing deleted successfully',
  },
};

export default messages;
